import { render, staticRenderFns } from "./table-view-dialog-box.vue?vue&type=template&id=2831d1e4&"
import script from "./table-view-dialog-box.vue?vue&type=script&lang=js&"
export * from "./table-view-dialog-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports